import React, {ReactNode} from 'react';
import {useParams} from 'react-router-dom';
import {Navigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface InsuranceServiceIdGuardProps {
  children(serviceId: string): ReactNode;
}

function InsuranceServiceIdGuard({children}: InsuranceServiceIdGuardProps): JSX.Element {
  const params = useParams();

  if (!params.serviceId) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(params.serviceId)}</>;
}

export default InsuranceServiceIdGuard;
